import { Pipe, PipeTransform } from '@angular/core';

import { Phone, Product, ProductFactory, PromotionModel, PromotionsModel } from '@bytel/bytel-sales';

@Pipe({
    name: 'priceWithoutCoupon',
    pure: true,
    standalone: true,
})
export class PriceWithoutCouponPipe implements PipeTransform {
    transform(product: Product): number {
        let price: number = product.prices.base;
        let promotions: PromotionModel[] = [];

        if (ProductFactory.Is(product, Phone)) {
            // remove fix promo to have base price with instant discount
            // promotions = product.promotions.automatic
            //     .filter((p) => p.reductionType !== REDUCTION_TYPE.FIX)
            //     .concat(product.promotions.manual);
        } else {
            promotions = product.promotions.automatic.concat(product.promotions.manual);
        }

        price -= promotions.reduce((acc, promotion) => acc + promotion.reductionAmount, 0);

        return Math.max(product.minPromoPrice, PromotionsModel.roundPrice(price));
    }
}
